import { h } from "preact";
import { useEffect, useMemo, useRef, useState } from "preact/hooks";
import { labelPreviewUrl } from "../../api/label-creator";

export function LabelPreview(props: {
    svg?: string,
    path?: string,
    maxWidth?: number,
    maxHeight?: number,
    fonts?: string[]
}) {
    const iframeRef = useRef<HTMLIFrameElement>(null);
    const [svgUrl, setSvgUrl] = useState("");
    const [svg, setSvg] = useState(props.svg ?? null);
    const [loading, setLoading] = useState(true);
    const maxWidth = props.maxWidth ?? 800;
    const maxHeight = props.maxHeight ?? 500;

    useMemo(() => {
        setLoading(true);

        if (props.path) {
            fetch(labelPreviewUrl(props.path)).then(v => v.text().then(t => setSvg(t)));
        }
        else if (props.svg !== svg) {
            setSvg(props.svg ?? null);
        }
    }, [props.path, props.svg, svg]);

    useEffect(() => {
        if (!svg) {
            iframeRef.current?.contentWindow?.location.replace("");
            return;
        }

        const url = URL.createObjectURL(new Blob([ svg ], { type: "image/svg+xml" }));

        setSvgUrl(url);

        iframeRef.current?.contentWindow?.location.replace(url);

        return () => {
            URL.revokeObjectURL(url);
        }
    }, [svg]);

    return <div>
        {loading ? <div class="loader"/> : null}
        <iframe key={props.path} ref={iframeRef} style={{
            width: (maxWidth) + "px",
            height: (maxHeight) + "px",
            border: "none",
            overflow: "hidden"
        }} onLoad={(e) => {
            const svg = e.currentTarget.contentDocument?.getElementsByTagName("svg").item(0);

            if (!svg) {
                e.currentTarget.style.height = "0px";
                setLoading(false);
                return;
            }

            if (e.currentTarget.contentDocument && props.fonts) {
                const defs = e.currentTarget.contentDocument.createElementNS("http://www.w3.org/2000/svg", "defs");
                const style = e.currentTarget.contentDocument.createElementNS("http://www.w3.org/2000/svg", "style");

                for (let i = 0; i < props.fonts.length; i++) {
                    style.textContent += `@import url('${props.fonts[i]}')\n`;
                }

                defs.appendChild(style);
                svg.appendChild(defs);
            }

            svg.style.background = "white";
            svg.style.overflow = "hidden";
            // svg.style.maxWidth = "800px";
            // svg.style.maxHeight = "500px";
            svg.style.width = "auto";
            svg.style.height = "auto";

            const rect = svg.getBoundingClientRect();

            let { width, height } = rect;
            let scale = 1;

            if (width > maxWidth) {
                scale = maxWidth / width;
            }
            else if (height > maxHeight) {
                scale = maxHeight / height;
            }

            width *= scale;
            height *= scale;

            svg.style.width = width + "px";
            svg.style.height = height + "px";
            e.currentTarget.style.width = width + "px";
            e.currentTarget.style.height = height + "px";

            setLoading(false);
        }}/>
    </div>;
}
